/** file này mới được tạo 28-6-2023
 * nên nhưng apo được tạo trừ trước ngày này hiện chưa có trong này
 */

import { STATUS_CODE } from '~/constants'
import request from './request'

/** list buffet
 * chỉ với nhà hàng tích hợp smaregi
 */
export const getListBuffet = async (storeId) => {
  const URL = `restaurants/${storeId}/buffet_menu`
  let params = {}

  try {
    const { data, status } = await request().get(URL, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.data || [],
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: [],
    }
  }
}
